<template>
  <div class="row notice_board_container">
    
    <div class="card">
      <div class="card-title">
        <h6>Notice Board</h6>
      </div>
      <div class="card-content">
        <div class="row data_row" v-for="item in notice_boards" v-html="item.description"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    notice_boards() {
      return this.$store.getters.notice_boards;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/style/colors.scss";
.notice_board_container {
  padding-top: 30px;
}

.card {
  border: 1px solid #005555;
  border-radius: 20px;
  padding-top: 10px;
  height: 300px;
}

.card .card-title {
  padding: 10px;
  text-align: center;
  background: $primaryColor;
  color: white;
  border-bottom: 2px solid white;
  border-radius: 50px;
  width: 40%;
  margin-left: 30%;
}

.card .card-content {
  color: white;
}

.data_row {
  color: black !important;
  border: 0.5px solid $primaryColor;
  padding: 5px;
  border-top: none;
  border-left: none;
  border-right: none;
  padding-bottom: 10px;
}
</style>